import englishMessages from './en-gb';
import germanMessages from './de-at';

export default {
  'en-gb': englishMessages,
  'de-at': germanMessages,
};
